module.exports = __webpack_public_path__ + "static/media/motorcycle.51089c2d.svg";